import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.1168 15.9959C8.66121 14.6301 6.99976 12.009 6.99976 8.99976C6.99976 4.58148 10.5815 0.999756 14.9998 0.999756C18.009 0.999756 20.6302 2.66126 21.996 5.11694C21.9957 5.11624 21.9955 5.11554 21.9952 5.11484C22.6355 6.26517 23.0002 7.58986 23.0002 8.99976C23.0002 13.418 19.4184 16.9998 15.0002 16.9998C15 16.9998 15.0003 16.9998 15.0002 16.9998C14.9656 16.9998 14.9308 16.9995 14.8964 16.9991C14.6904 16.9965 14.4864 16.9861 14.2845 16.9682L12.8606 18.3672C12.2247 19.0002 11.3485 19.0713 10.613 18.9372C10.1023 18.8441 9.57464 18.6419 9.05869 18.3586L7.99976 19.4151C7.99503 19.9211 7.96394 20.59 7.78528 21.1848C7.66339 21.5905 7.45155 22.043 7.06388 22.4023C6.65633 22.78 6.13071 22.9838 5.52596 22.9994C4.89679 23.0157 4.36516 22.8121 3.95883 22.4576C3.57509 22.1228 3.35816 21.7028 3.23231 21.3546C3.1752 21.1966 3.13251 21.0414 3.10047 20.8967C2.95675 20.8644 2.80273 20.8216 2.64595 20.7646C2.2987 20.6383 1.88023 20.4215 1.54603 20.0395C1.19233 19.6353 0.98676 19.1059 1.00039 18.478C1.01356 17.8717 1.21822 17.3451 1.59708 16.9376C1.95678 16.5507 2.40985 16.3391 2.81533 16.2171C3.41122 16.0379 4.08045 16.0056 4.58601 16.0004L5.69246 14.8967C5.44702 14.4112 5.27466 13.9163 5.20125 13.4366C5.09266 12.7269 5.187 11.8987 5.79306 11.2927L5.79929 11.2864L6.0588 11.0315C6.08707 11.1055 6.11639 11.1792 6.14678 11.2526C6.79012 12.8057 7.87959 14.1332 9.27741 15.0672C9.85367 15.4523 10.4717 15.7633 11.1168 15.9959ZM6.84848 16.5685L5.41364 17.9998H5.00016C4.40872 17.9998 3.83061 18.0002 3.39145 18.1323C3.18751 18.1937 3.09729 18.2613 3.06189 18.2993C3.04541 18.3171 3.00338 18.3622 2.99992 18.5215C2.99691 18.6603 3.03301 18.7018 3.05119 18.7225C3.08887 18.7656 3.17248 18.8279 3.3294 18.885C3.48199 18.9405 3.65058 18.9715 3.79188 18.987C3.85974 18.9944 3.91492 18.9976 3.9503 18.9989C3.96784 18.9996 3.98006 18.9997 3.98603 18.9998L3.98858 18.9998L3.99005 18.9998L5.02016 18.9829L5.00006 20.0129L5.00006 20.0144L5.00007 20.017C5.0001 20.023 5.00026 20.0353 5.00086 20.0529C5.00209 20.0884 5.00511 20.1437 5.01237 20.2118C5.02748 20.3535 5.0581 20.5223 5.1132 20.6747C5.16988 20.8315 5.23172 20.9139 5.27358 20.9505C5.29301 20.9674 5.33459 21.0037 5.47436 21.0001C5.63914 20.9958 5.6861 20.9523 5.70423 20.9355C5.74216 20.9004 5.80919 20.8113 5.86984 20.6094C6.00017 20.1755 6.00016 19.6058 6.00016 19.0119V18.5849L7.42686 17.1615C7.35258 17.0922 7.27926 17.0215 7.20727 16.9495C7.0834 16.8256 6.96354 16.6981 6.84848 16.5685Z"}}]};

const DrumstickFilled = Vue.extend<IconProps>({
  name: 'DrumstickFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'drumstick-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DrumstickFilled;
